import { IAccommodationRecord, TAResponse3 } from 'api/tripadvisor/types';
import { SortByAccommodations } from 'components/common/SortAccomodations/constants';

export const accommodationSortingBySortType: { [key in SortByAccommodations]: (a: IAccommodationRecord, b: IAccommodationRecord) => number } = {
  [SortByAccommodations.RATING]: (a: IAccommodationRecord, b: IAccommodationRecord) => (+b.rating) - (+a.rating),
  [SortByAccommodations.NAME]: (a: IAccommodationRecord, b: IAccommodationRecord) => (a.name ?? '').localeCompare(b.name ?? ''),
  [SortByAccommodations.PRICE]: (a: IAccommodationRecord, b: IAccommodationRecord) => (a.name ?? '').localeCompare(b.name ?? ''),
};

export const sortAccommodationsByPrice = (
  acc: Array<IAccommodationRecord>,
  offers: Record<string, Array<TAResponse3.Offer>>,
  curSortBy: SortByAccommodations,
) => acc.sort((a1, a2) => {
  const a1Offer = offers[a1.location_id];
  const a2Offer = offers[a2.location_id];

  if (a1Offer?.length === 0) {
    return 1;
  }
  if (a2Offer?.length === 0) {
    return -1;
  }

  const a1HasPrice = !!a1Offer?.find((o) => o.displayPrice);
  const a2HasPrice = !!a2Offer?.find((o) => o.displayPrice);

  if (a1HasPrice === a2HasPrice) {
    if (curSortBy === SortByAccommodations.RATING) {
      return (+a2.rating) - (+a1.rating);
    }
    if (curSortBy === SortByAccommodations.PRICE && a1HasPrice) {
      const a1price = a1Offer.find((o) => o.price)?.price;
      const a2price = a2Offer.find((o) => o.price)?.price;

      if (a1price && a2price) {
        return a1price - a2price;
      }
    }
    return (a1.name ?? '').localeCompare(a2.name ?? '');
  }
  if (a1HasPrice) {
    return -1;
  }
  return 1;
});
